import { createContext } from "react";

export interface ISWReactTableWrapperSelectionContext {
    selectedRows: any[];
    onRowSelection: (row: FixmeType) => void;
    onSelectAllRows: (rows: FixmeType) => void;
    clearAllSelectedRows: () => void;
    isRowSelected: (row: FixmeType) => boolean;
    allRowsSelected: boolean;
    selectRows: (rows: FixmeType) => void;
    getStoreRow: (row: FixmeType) => any;
    changePageCallback?: (page: number) => void;
    totalRecord?: number;
    textFilter?: string;
    maxSelectedRows?: number;
}

const defaultValue = {
    selectedRows: [],
    onRowSelection: (row: FixmeType) => null,
    onSelectAllRows: (rows: FixmeType) => null,
    clearAllSelectedRows: () => null,
    isRowSelected: (row: FixmeType) => false,
    allRowsSelected: false,
    selectRows: (rows: FixmeType) => null,
    getStoreRow: (row: FixmeType) => null,
};

const SWReactTableWrapperContext = createContext<ISWReactTableWrapperSelectionContext>(defaultValue);
export const SWReactTableWrapperContextProvider = SWReactTableWrapperContext.Provider;
export const SWReactTableWrapperContextConsumer = SWReactTableWrapperContext.Consumer;
